// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision.broadphase

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Class that determines if an object layer can collide with a broadphase layer.
 * This implementation uses a table and constructs itself from an ObjectLayerPairFilter and a BroadPhaseLayerInterface.
 *
 * C++ `JPH::ObjectVsBroadPhaseLayerFilterTable`.
 */
class ObjectVsBroadPhaseLayerFilterTable internal constructor(internal val objectVsBroadPhaseLayerFilterTableHandle: NativePointer, owned: Boolean = false) : ObjectVsBroadPhaseLayerFilter(JphObjectVsBroadPhaseLayerFilterTable_asObjectVsBroadPhaseLayerFilter(objectVsBroadPhaseLayerFilterTableHandle), owned), AutoCloseable {
    constructor(broadPhaseLayerInterface: BroadPhaseLayerInterface, numBroadPhaseLayers: Int, objectLayerPairFilter: ObjectLayerPairFilter, numObjectLayers: Int) : this(JphObjectVsBroadPhaseLayerFilterTable_create(broadPhaseLayerInterface.broadPhaseLayerInterfaceHandle, numBroadPhaseLayers, objectLayerPairFilter.objectLayerPairFilterHandle, numObjectLayers), owned = true)

    override fun close() =
        closeOnce { JphObjectVsBroadPhaseLayerFilterTable_destroy(objectVsBroadPhaseLayerFilterTableHandle) }
}
